if (!window.__pcAddToCartBound) {
  window.__pcAddToCartBound = true;

  document.addEventListener('click', async (event) => {
    const button = event.target.closest('[data-pc-add-to-cart]');
    if (!button || button.disabled) return;

    event.preventDefault();

    const variantId = button.getAttribute('data-variant-id');
    if (!variantId) return;

    const defaultLabel = button.getAttribute('data-label-default') || button.textContent.trim();
    const addedLabel = button.getAttribute('data-label-added') || 'Ajouté !';
    const errorLabel = button.getAttribute('data-label-error') || 'Erreur';

    button.disabled = true;
    button.textContent = '...';

    try {
      const addResponse = await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
        body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] }),
      });

      if (!addResponse.ok) {
        const errorBody = await addResponse.json().catch(() => null);
        throw new Error(errorBody?.description || 'add to cart failed');
      }

      const cartResponse = await fetch('/cart.js');
      const cart = await cartResponse.json();

      const cartIcon = document.querySelector('cart-icon');
      if (cartIcon && typeof cartIcon.renderCartBubble === 'function') {
        cartIcon.renderCartBubble(cart.item_count);
      }

      button.textContent = addedLabel;
    } catch (error) {
      console.warn('[pc-add-to-cart]', error);
      button.textContent = errorLabel;
    } finally {
      setTimeout(() => {
        button.textContent = defaultLabel;
        button.disabled = false;
      }, 1800);
    }
  });
}
